import { CopyButton } from "@/components/ui/CopyButton";
import { Breadcrumbs, Typography } from "@mui/material";

type Props = {
  id: string;
};

export function MaskBreadcrumbs({ id }: Props) {
  return (
    <Breadcrumbs separator="·">
      <CopyButton text={id}>
        <Typography>{`Mask ID: ${id}`}</Typography>
      </CopyButton>
    </Breadcrumbs>
  );
}
